export {
    setLangCookie,
    getLangCookie,
    redirectFromLangCookie,
} from './langCookie'
